<template>
  <v-navigation-drawer width="480" v-model="show" absolute right temporary>
    <!-- Header -->
    <v-sheet color="primary" dark class="pa-3 d-flex align-center justify-space-between">
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-list-status</v-icon>
        <span class="text-subtitle-1 font-weight-bold">Histórico de Pagamentos</span>
      </div>
      <v-btn icon small @click="show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-sheet>

    <div class="pa-4">
      <div class="text-subtitle-1 font-weight-bold text--primary">
        {{ parcela.matricula ? parcela.matricula.aluno.nomecompleto : "—" }}
      </div>
      <div class="text-caption grey--text text--darken-1 mb-3">
        {{ parcela.matricula ? parcela.matricula.turma.descricao : "—" }}
      </div>

      <v-chip small color="grey lighten-3" class="mb-4">
        <v-icon x-small left>mdi-pound</v-icon>
        {{ parcela.descricao || `Parcela ${parcela.numero || "—"}` }}
      </v-chip>

      <v-row dense class="mb-2">
        <v-col cols="4" class="text-center">
          <div class="text-caption grey--text mb-1">Valor</div>
          <v-chip small color="blue darken-1" class="white--text font-weight-bold">
            {{ parcela.valor | currency }}
          </v-chip>
        </v-col>
        <v-col cols="4" class="text-center">
          <div class="text-caption grey--text mb-1">Pago</div>
          <v-chip
            small
            :color="parcela.valorpago > 0 ? 'green darken-1' : 'grey lighten-1'"
            :class="
              parcela.valorpago > 0 ? 'white--text font-weight-bold' : 'grey--text text--darken-1'
            "
          >
            {{ parcela.valorpago | currency }}
          </v-chip>
        </v-col>
        <v-col cols="4" class="text-center">
          <div class="text-caption grey--text mb-1">Em aberto</div>
          <v-chip
            small
            :color="calcularValorAberto(parcela) > 0 ? 'orange darken-2' : 'green darken-1'"
            class="white--text font-weight-bold"
          >
            {{ calcularValorAberto(parcela) | currency }}
          </v-chip>
        </v-col>
      </v-row>

      <div v-if="parcela.desconto > 0" class="text-caption grey--text mt-1 mb-3">
        Desconto:
        <span class="blue--text text--darken-2 font-weight-medium">
          {{ parcela.desconto | currency }}
        </span>
      </div>

      <div class="d-flex mt-3">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!user.caixa"
              small
              color="info"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="() => openModalBaixarParcela(parcela, parcela.matricula)"
            >
              <v-icon small left>mdi-arrow-down-circle</v-icon>
              Baixar
            </v-btn>
          </template>
          <span>Baixar parcela</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!user.caixa"
              small
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="(modalRecibo = true), reciboDaParcela(parcela.id)"
            >
              <v-icon small left>mdi-receipt</v-icon>
              Recibo
            </v-btn>
          </template>
          <span>Recibo da parcela</span>
        </v-tooltip>
      </div>
    </div>

    <v-divider></v-divider>

    <div class="px-4 pt-3 pb-1 d-flex align-center">
      <v-icon small class="mr-1 grey--text">mdi-history</v-icon>
      <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1">
        Movimentações ({{ listaDeParcelas ? listaDeParcelas.length : 0 }})
      </span>
    </div>

    <div class="px-2">
      <div
        v-if="!listaDeParcelas || listaDeParcelas.length === 0"
        class="text-center grey--text text-caption py-6"
      >
        Nenhuma movimentação registrada.
      </div>

      <v-timeline align-center dense class="pt-1" v-else>
        <v-timeline-item
          small
          v-for="item in listaDeParcelas"
          :key="item.id"
          :color="item.estorno ? 'red darken-1' : 'green darken-1'"
        >
          <div class="d-flex align-center justify-space-between py-1">
            <div>
              <div class="d-flex align-center flex-wrap mb-1" style="gap: 4px">
                <v-chip
                  x-small
                  :color="item.estorno ? 'red lighten-4' : 'green lighten-4'"
                  :text-color="item.estorno ? 'red darken-3' : 'green darken-3'"
                  class="font-weight-bold"
                >
                  {{ item.estorno ? "−" : "+" }} {{ item.valor | currency }}
                </v-chip>
                <v-chip v-if="item.estorno" x-small color="red lighten-4" text-color="red darken-3">
                  Estornado
                </v-chip>
              </div>
              <div class="text-caption grey--text">{{ item.created_at | longDate }}</div>
              <div v-if="item.user" class="text-caption grey--text text--darken-1 mt-1">
                <v-icon x-small class="mr-1">mdi-account-outline</v-icon>{{ item.user.name }}
              </div>
            </div>

            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="!user.caixa"
                    x-small
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="(modalRecibo = true), comprovante(item.id)"
                  >
                    <v-icon small>mdi-receipt</v-icon>
                  </v-btn>
                </template>
                <span>Comprovante de pagamento</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="!user.caixa || !!item.estorno"
                    x-small
                    icon
                    color="red darken-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="[adicionarItem(item), (modalEstorno = true)]"
                  >
                    <v-icon small>mdi-file-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Estornar pagamento</span>
              </v-tooltip>
            </div>
          </div>
        </v-timeline-item>
      </v-timeline>
    </div>

    <v-dialog v-model="modalEstorno" persistent max-width="400">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold pb-1">
          <v-icon color="orange darken-2" left>mdi-alert-outline</v-icon>
          Confirmar estorno
        </v-card-title>
        <v-card-text>
          <span v-if="!item.estorno">
            Deseja estornar o valor de
            <strong class="red--text">{{ item.valor | currency }}</strong
            >? Essa ação não poderá ser desfeita.
          </span>
          <span v-else class="grey--text">Este pagamento já foi estornado.</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="modalEstorno = false">Cancelar</v-btn>
          <v-btn
            :disabled="!!item.estorno"
            color="red darken-1"
            text
            @click="[estornaValor(), (modalEstorno = false)]"
          >
            Confirmar Estorno
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalCarteira
      :title="title"
      :dialog="modalRecibo"
      :pdf="pdf"
      @CloserModalRecibo="modalRecibo = false"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import ModalCarteira from "../Matriculas/EModalCarteira.vue";

export default {
  computed: {
    ...mapGetters("Auth", ["user"]),
  },

  components: {
    ModalCarteira,
  },

  data() {
    return {
      title: "Recibo",
      item: {},
      modalRecibo: false,
      modalEstorno: false,
      dialog: false,
      pdf: null,
    };
  },

  props: {
    listaDeParcelas: {
      type: Array,
    },
    show: {
      type: Boolean,
    },
    parcela: {
      type: Object,
    },
    matricula: {
      type: Number,
    },
  },

  methods: {
    calcularValorAberto(parcela) {
      const diff = parcela.valor - parcela.valorpago - parcela.desconto;
      return Math.abs(diff) < 0.000001 ? 0 : diff;
    },

    async comprovante(mensalidade) {
      this.pdf = await this.$services.relatoriosService.exibirRecibo(mensalidade);
    },

    async reciboDaParcela(parcelaId) {
      this.title = "Recibo da parcela";
      this.pdf = await this.$services.relatoriosService.exibirReciboDaParcela(parcelaId);
    },

    adicionarItem(item) {
      this.item = { ...item };
    },

    async estornaValor() {
      const data = {
        id: this.item.id,
        estorno: 1,
        valor: -this.item.valor,
      };
      await this.$services.parcelasService.estorno(data).then(() => {
        this.$emit("valorEstornado", true);
      });
      this.modalEstorno = false;
    },

    openModalBaixarParcela(parcela, matriculaSelecionada) {
      this.parcela = { ...parcela };
      this.$router.push({
        name: "mensalidades.baixar",
        params: { prestacao_id: this.parcela.id, matricula_id: matriculaSelecionada.id },
      });
    },
  },
};
</script>
